import MotorTermsAndConditions from './MotorTermsAndConditions';

export default MotorTermsAndConditions;
